import React from "react";
import styled from "styled-components";
import Chart from "./chart";

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export interface IProps {
  data: number[];
  color?: string;
  className?: string;
  polarizeColors?: boolean;
  disableAnimation?: boolean;
}

const Sparkline = ({
  polarizeColors,
  data,
  color,
  className,
  disableAnimation,
}: IProps) => {
  return (
    <Root className={className}>
      <Chart
        polarizeColors={polarizeColors}
        data={data}
        color={color}
        disableAnimation={disableAnimation}
      />
    </Root>
  );
};

export default Sparkline;
